import { h, render, Component } from 'preact';
import { appConfig } from '../app.config';


class TxrContactUsHsForm extends Component {
    state = {
        
    }

    
    render() {
        return (
            <div class="txr-contact-us-hs-form">
                <script src={'https://js.hsforms.net/forms/embed/'+ appConfig.hubspotPortalId +'.js'} defer></script>
                <div class="hs-form-frame" data-region="na1" data-form-id={appConfig.hubspotContactUsFormId} data-portal-id={appConfig.hubspotPortalId}></div>
            </div>
        )
    }
}

export default TxrContactUsHsForm;
